<error-error-content 
  image="assets/img/images/error-images/image1.png"
  title="System unavailable"
  copy="We are working to restore services as quickly as possible."></error-error-content>
